<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：我购买了可瀚学堂，怎么激活课程呢？</p>
      <p>答：请在课程激活卡背面找到“邀请码”</p>
      <p>【方式一】请访问https://kehigh.com/vip 输入您的手机号，和邀请码，即可激活。然后用这个手机号登录可瀚学堂App即可学习您购买的课程。</p>
      <p>【方式二】请登录可瀚学堂App后，点击我的——激活课程——输入邀请码即可激活您购买的课程。</p>
      <div class="ha-img">
        <img src="./img/active.png" alt="">
      </div>
      <p>当故事旁边没有“锁”的标志，且可以进入观看视频及跟读，即表示此故事已激活。</p>
      <!-- 点击 <a href="https://www.kehigh.com/vip">https://www.kehigh.com/vip</a>，输入激活码激活即可。
      <p>安卓用户：除了用上面方式激活，也可以如下图在App中点击【我的】，再选择【激活课程】，输入这20位数字，即可激活课程。</p>
    </div>
    <div class="ha-img">
      <img src="./img/active.png" alt="">
    </div>
    <div class="ha-des">
      <p>当故事旁边没有“锁”的标志，且可以进入观看视频及跟读，即表示此故事已经激活。（根据不同学校定制课程包，您已激活的课程可能分散在“初级、中级、高级”里面，这是为了与学校的教学计划相符。）</p>
    </div>-->
    <div class="ha-img-02">
      <img src="./img/class_active.png" alt=""> 
    </div>
  </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      padding-right: p2r(30);
      img {
        width: 100%;
      }
    }
    .ha-img-02 {
      img {
        width: 90%;
      }
      padding-right: p2r(30);
      text-align: right;
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title = "如何激活课程? 可瀚学堂-深圳市格熙信息科技有限公司"
      this.$sendAnalytics('点击如何激活课程')
    },
    components: {}
  }
</script>
